
export const loadMessages = async (localeToLoad) => {
switch (localeToLoad) {
case 'fr-CA/messages.js_':  return (await import("./fr-CA/messages")).messages;
case 'en-US/messages.js_':  return (await import("./en-US/messages")).messages;
case 'en-CA/messages.js_':  return (await import("./en-CA/messages")).messages;
case 'fr-FR_episens':  return (await import("./fr-FR-episens/messages")).messages;
case 'fr-FR/messages.js_':  return (await import("./fr-FR/messages")).messages;
case 'fr-FR_aladin':  return (await import("./fr-FR-aladin/messages")).messages;
case 'fr-FR_emoji':  return (await import("./fr-FR-emoji/messages")).messages;
case 'en-US_countrymalt':  return (await import("./en-US-countrymalt/messages")).messages;
case 'en-CA_countrymalt':  return (await import("./en-CA-countrymalt/messages")).messages;
case 'fr-FR_farmi':  return (await import("./fr-FR-farmi/messages")).messages;
case 'fr-CA_countrymalt':  return (await import("./fr-CA-countrymalt/messages")).messages;
}; };
